import React from "react";
import { Link2, ChevronRight } from "lucide-react";
import TestRunNew from "../../doc/TestRunNew";

export default function StageDocumentView({
  stage,
  project,
  isCompleted,
  onCompleteStage,
  onNextStage,
  isLastStage,
}) {
  const formId = stage?.formId;

  return (
    <div className="stage-document-container">
      {formId ? (
        <TestRunNew
          formId={formId}
          onCompleteStage={() => {
            if (onCompleteStage) onCompleteStage(stage.id);
          }}
          onNextStage={onNextStage}
          isLastStage={isLastStage}
        />
      ) : (
        <div
          style={{
            textAlign: "center",
            padding: "40px",
            background: "var(--bg)",
            borderRadius: "10px",
            border: "1px dashed var(--line)",
            color: "var(--mute)",
          }}
        >
          <Link2 size={28} color="var(--mute)" style={{ margin: "0 auto 8px" }} />
          <p style={{ fontSize: "13.5px", fontWeight: "600", margin: "0 0 4px" }}>
            No document linked to this stage yet
          </p>
          <span style={{ fontSize: "12px", color: "var(--mute)" }}>
            When a document is connected in stage administration, it will show here.
          </span>
        </div>
      )}

      {isCompleted && (
        <div
          style={{
            marginTop: "16px",
            paddingTop: "12px",
            borderTop: "1px dashed var(--line)",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <button
            type="button"
            onClick={onNextStage}
            style={{
              background: "linear-gradient(var(--blue), var(--blue-2))",
              color: "var(--white)",
              border: "none",
              borderRadius: "6px",
              padding: "8px 18px",
              fontSize: "12.5px",
              fontWeight: "700",
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              boxShadow: "0 2px 4px rgba(37, 99, 235, 0.25)",
            }}
          >
            <span>{isLastStage ? "Complete" : "Next Stage"}</span>
            <ChevronRight size={16} />
          </button>
        </div>
      )}
    </div>
  );
}
